<template>
  <section class="carousel carousel--full">
    <div class="owl-carousel">
      <div class="carousel__item" v-for="prize in getCarouselPrizes" :key="prize.type">
        <div class="carousel__item__content">
          <h1>{{ prize.headline }}</h1>
          <div class="prize-icon">
            <img src="static/images/prize-icon.svg" alt="">
            <span v-if="prize.type === 'DAILY'">
              {{ getTranslations.home_carousel_day1 }}<br>{{ getTranslations.home_carousel_day2 }}
            </span>
            <span v-if="prize.type === 'MONTHLY'">
              {{ getTranslations.home_carousel_month1 }}<br>{{ getTranslations.home_carousel_month2 }}
            </span>
            <span v-if="prize.type === 'WEEKLY'">
              {{ getTranslations.home_carousel_week1 }}<br>{{ getTranslations.home_carousel_week2 }}
            </span>
            <span v-if="prize.type === 'GRAND'">
              {{ getTranslations.home_carousel_grand1 }}<br>{{ getTranslations.home_carousel_grand2 }}
            </span>
          </div>
          <img :src="prize.imgUrl" alt="" class="prize-image">
        </div>
      </div>
    </div>
    <div class="carousel__nav"></div>
    <div class="carousel__dots"></div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import 'owl.carousel';

export default {
  name: 'carousel',
  methods: {
    ...mapActions('profile', [
      'storeAvailablePrizeTypes',
    ]),
  },
  mounted() {
    this.storeAvailablePrizeTypes(this.getLocale).then(() => {
      this.$nextTick(() => {
        /*eslint-disable */
        // default home page carousel
        $('.owl-carousel').owlCarousel({
         loop: this.getCarouselPrizes.length > 1 ? true : false,
         responsiveClass: true,
         dots: this.getCarouselPrizes.length > 1 ? true : false,
         autoplay: this.getCarouselPrizes.length > 1 ? true : false,
         autoplayTimeout: 5000,
         autoplayHoverPause: this.getCarouselPrizes.length > 1 ? true : false,
         navContainer: '.carousel__nav',
         dotsContainer: '.carousel__dots',
         navText: this.getCarouselPrizes.length > 1 ? ['<i class=\'icon-arrow-left\'></i>', '<i class=\'icon-arrow-right\'></i>'] : '',
         responsive: {
           0: {
             items: 1,
             nav: true,
           },
         },
        });
      });
    });
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
      'getLocale',
    ]),
    ...mapGetters('profile', [
      'getDailyPrize',
      'getWeeklyPrize',
      'getMonthlyPrize',
      'getCarouselPrizes',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/Carousel.vue